import type { TagsManager } from 'dxf-writer'
import DxfSpline from 'dxf-writer/src/Spline.js'

/**
 * DXF 样条曲线（SPLINE）实体，扩展 dxf-writer Spline 以支持线型、线宽、真彩色与拟合点。
 */
export default class Spline extends DxfSpline {
  /** 线型名称，默认跟随图层 */
  lineType: string = 'ByLayer'
  /** 线宽，单位百分之毫米；-1 表示跟随图层 */
  lineWidth: number = -1
  /** 真彩色 RGB 整数，undefined 表示不写入 */
  trueColor: number | undefined

  /** 拟合点坐标数组，组码 11/21 */
  fitPoints: Array<[number, number]> = []

  constructor(...args: any[]) {
    super(...args)
  }

  /**
   * 写入 SPLINE 组码序列。
   *
   * @param manager - DXF 标签写入器
   */
  tags(manager: TagsManager) {
    super.tags(manager)
    manager.push(6, this.lineType)
    manager.push(62, 256)
    manager.push(370, this.lineWidth)
    if (this.trueColor !== undefined) {
      manager.push(420, this.trueColor)
    }
    this.fitPoints.forEach((point) => {
      const [x, y] = point
      manager.push(11, x)
      manager.push(21, y)
    })
  }
}
